import { ReactElement } from 'react'
import Image from 'next/image'
import { AspectRatio, Flex, Container, Box } from '@chakra-ui/react'

import SectionContent from '@/features/Services/components/molecules/SectionContent'

import { Policy, PolicyDatum } from '@/features/Services/types'

interface Props {
  id?: string
  name: string
  primaryColor: string
  secondaryColor: string
  policy: Policy
  index: number
}

function Section({
  id,
  index,
  name,
  primaryColor,
  secondaryColor,
  policy,
}: Props): ReactElement {
  const isEven = index % 2 === 0

  return (
    <Container
      sx={{
        w: 'full',
        maxWidth: '1178px',
        py: {
          base: '60px',
          md: '100px',
        },
        px: {
          base: '0',
          md: '100px',
          'lg+': '0',
        },
      }}
    >
      {policy.component ? (
        policy.component
      ) : (
        <Flex
          id={id}
          direction={{
            base: 'column-reverse',
            'lg+': !isEven ? 'row-reverse' : 'row',
          }}
          sx={{
            w: 'full',
            m: 'auto',
            alignItems: 'center',
            '& > *': {
              p: 8,
              flex: '0 1',
              flexBasis: {
                base: 'auto',
                'lg+': '50%',
              },
              w: {
                base: '100%',
                'lg+': '50%',
              },
              maxW: {
                base: '720px',
                'lg+': '50%',
              },
              minW: {
                base: 'unset',
                'lg+': '50%',
              },
            },
          }}
        >
          <SectionContent
            {...(policy as PolicyDatum)}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            initialInView={index === 0}
          />
          <Box>
            {policy.image && typeof policy.image === 'string' ? (
              <AspectRatio ratio={policy.imageAspectRatio}>
                <Image
                  src={policy.image}
                  alt={name}
                  layout="fill"
                  objectFit="contain"
                />
              </AspectRatio>
            ) : (
              policy.image
            )}
          </Box>
        </Flex>
      )}
    </Container>
  )
}

Section.defaultProps = {
  index: 0,
}

export default Section
